import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SkillWithMicroSkillDetailsFragmentDoc, MicroSkillFragmentDoc } from '../../../../skill-matrix/views/SkillsManager/components/Dialogs/components/SkillsDetails/graphql/query/generated/skillMicroSkillDetails';
import { SkillDetailsFragmentDoc } from '../../../../skill-matrix/graphql/fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MicroSkillsQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.SkillsFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type MicroSkillsQuery = { skills: { edges?: Array<{ node: { __typename: 'SkillType', childrenIds?: Array<string> | null, id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, childSkills?: Array<{ id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null }> | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null } }> | null } };


export const MicroSkillsDocument = /*#__PURE__*/ gql`
    query microSkills($sort: [SortType!], $filters: SkillsFilters, $after: String, $first: Float) {
  skills(filters: $filters, first: $first, sort: $sort, after: $after) {
    edges {
      node {
        ...SkillWithMicroSkillDetails
      }
    }
  }
}
    ${SkillWithMicroSkillDetailsFragmentDoc}
${SkillDetailsFragmentDoc}
${MicroSkillFragmentDoc}`;

export function useMicroSkillsQuery(options?: Omit<Urql.UseQueryArgs<MicroSkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<MicroSkillsQuery, MicroSkillsQueryVariables>({ query: MicroSkillsDocument, ...options });
};